<!--
component: ImageViewer
author: Ken Nakamura
description: 画像表示コンポーネント
-->
<template>
  <section class="image-viewer">
    <div style="width:100%; height:100%">
    <!-- <section class="image-viewer grab-bing scroll-hidden" v-dragscroll> -->
    <!-- <v-img id="img" contain :src="imageUrl" :alt="altText" height="100%" width="100%" position="center center" @drag="aa()"> -->
    <!-- <v-img id="img" contain :src="imageUrl" :alt="altText" height="100%" width="100%" :style="{'transform': `scale(${scale}`}" position="center center" @mousewheel="imagScale($event)"> -->
    <v-img
      id="img"
      class="grab-bing pb-1"
      contain :src="imageUrl"
      :alt="altText"
      :height="imgHeight"
      :width="imgWidth"
      :style="{'transform': `scale(${scale}`}"
      position="top center"
      @click="onClick($event)"
      @mousedown="onMouseDown($event)"
      @mouseup="onMouseUp()"
      @mouseleave="onMouseLeave($event)"
      @mousewheel="imagScale($event)"
      @mousemove="mousePosition($event)"
      @loadstart="loading=true"
      @load="imageLoaded"
      @error="loadError"
    >
      <template v-slot:placeholder>
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
      <span class="description">
        <div v-for="(desc, index) in descText" :key="index">
        {{desc}}
        </div>
      </span>
    </v-img>
    </div>
    <Dialog search :open="loading" :cancel="cancelLoad" title="読み込み中" body="お待ちください。"/>
    <Dialog error :open="error" title="エラー" :close="dialogClose" :body="errMessage"/>
  </section>
</template>

<script>
import Dialog from '../components/Dialog.vue'

export default {
  components: {
		Dialog,
  },
  data() {
    return {
      canvas: null,
      ctx: null,
      scale: 0,
      transX: 0,
      transY: 0,
      defaultTop: 0,
      defaultBottom: 0,
      defaultLeft: 0,
      defaultRight: 0,
      startY: 0,
      startX: 0,
      endY: 0,
      endX: 0,
      imgY: 0,
      imgX: 0,
      mouseEnter: false,
      mouseDown: false,
      loading: false,
      imgWidth: '100%',
      imgHeight: '100%',
      image: null,
      imageWidth: 0,
      imageHeight: 0,
      offsetLeft: 0,
      offsetTop: 0,
      error: false,
      errMessage: '読み込めません',
    }
  },
  props: {
    imageUrl: {
      type: String,
      required: true,
    },
    altText: {
      type: String,
      default: '',
    },
    descText: {
      type: Array,
      default: null,
    },
    scaleSize:{
      type: Number,
      default: 1,
    },
    mouseClick: {
      type: Function,
      default: null,
    },
  },
  watch:{
    scaleSize: {
      immediate: true,
      handler(value) {
        this.scale = value;
        if (value == 1) {
          this.transX = 0;
          this.transY = 0;
          let img = document.getElementById('img');
          if (img && img.style) {
            img.style.top = '0px';
            img.style.left = '0px';
          }
        }
      }
    },
    imageUrl: {
      immediate: true,
      handler(value) {
        if (value) {
          this.initImageInfo(value);
        }
      }
    },
  },
  mounted () {
    this.defaultTop = document.getElementById('img').getBoundingClientRect().top;
    this.defaultBottom = document.getElementById('img').getBoundingClientRect().bottom;
    this.defaultLeft = document.getElementById('img').getBoundingClientRect().left;
    this.defaultRight = document.getElementById('img').getBoundingClientRect().right;
  },
  computed: {
  },
  methods: {
    /*
    dragStart(event){
      this.startY = event.clientY;
      this.startX = event.clientX;
    },
    dragEnd(event){
      let img = document.getElementById('img');
      // 終了位置- 開始位置
      let y = event.clientY - this.startY;
      let x = event.clientX - this.startX;
      img.style.top = y + 'px';
      img.style.left = x + 'px';
    },
    */
    /**
     * 対象物の拡大・縮小を行います。（縮小は元の大きさ以下にはなりません。）
     * @author: takumi ogura
    */
    imagScale(event) {
      event.preventDefault();
      var tmpScale =  this.scaleSize;
      /* 引数event.deltaYの値によって画像の拡大・縮小の計算を行う。
         event.deltaY: マウスホイール(前)の場合、返却値 -100
                       マウスホイール(後)の場合、返却値 100
      */
      event.deltaY == -100 ? tmpScale += event.deltaY * -0.01 : tmpScale -= event.deltaY * 0.01;
      // 対象画像の大きさが初期表示サイズより縮小しないための分岐
      if(tmpScale >= 1 ){
        this.scale = Math.min(Math.max(.150, tmpScale), 10);
        document.getElementById('img').style.transformOrigin = `${this.transX}px ${this.transY}px`;
        this.$emit('updateScaleSize', this.scale);
      }
    },
    mousePosition(event){
      this.transX = event.offsetX;
      this.transY = event.offsetY;
      this.$emit('mouseMove', {
        x: event.offsetX - this.offsetLeft,
        y: event.offsetY - this.offsetTop
      });
      if (this.mouseDown) {
        this.endX = event.clientX;
        this.endY = event.clientY;
        const img = document.getElementById('img');
        this.imgX += this.endX - this.startX;
        this.imgY += this.endY - this.startY;
        img.style.left = this.imgX + 'px';
        img.style.top = this.imgY + 'px';
        this.startX = this.endX;
        this.startY = this.endY;
        this.$emit('imgMoved', {
          x: this.imgX, y: this.imgY
        });
      }
    },
    onMouseDown(event) {
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.mouseDown = true;
    },
    onMouseUp() {
      this.mouseDown = false;
    },
    onMouseLeave(event) {
      if (this.mouseDown) {
        this.endX = event.clientX;
        this.endY = event.clientY;
        const img = document.getElementById('img');
        this.imgX += this.endX - this.startX;
        this.imgY += this.endY - this.startY;
        img.style.left = this.imgX + 'px';
        img.style.top = this.imgY + 'px';
        this.startX = this.endX;
        this.startY = this.endY;
        this.$emit('imgMoved', {
          x: this.imgX, y: this.imgY
        });
        this.mouseDown = false;
      }
    },
    onClick(event) {
      if (this.mouseClick) {
        const x = event.offsetX - this.offsetLeft;
        const y = event.offsetY - this.offsetTop;
        this.mouseClick(x, y);
      }
    },
    loadImage(src) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = src;
        image.onload = function(){
          resolve(image);
        }
        image.onerror = function(error){
          reject(error);
        }
      });
    },
    initImageInfo(srcUrl) {
      this.loadImage(srcUrl)
      .then(img => {
        this.imageWidth = img.width;
        this.imageHeight = img.height;
        const elm = document.getElementById('img');
        if (elm && elm.parentElement) {
          const parent = elm.parentElement;
          const wratio = parent.clientWidth / this.imageWidth;
          const hratio = parent.clientHeight / this.imageHeight;
          //
          if (wratio > hratio) {
            const w = parent.clientHeight * this.imageWidth / this.imageHeight;
            this.imgWidth = w + 'px';
            if (this.$store.state.mode == 7) {
              this.imgHeight = (parent.clientHeight + 100) + 'px';
            }
            else {
              this.imgHeight = parent.clientHeight + 'px';
            }
          }
          else {
            const h = parent.clientWidth * this.imageHeight / this.imageWidth;
            this.imgWidth = parent.clientWidth + 'px';
            if (this.$store.state.mode == 7) {
              this.imgHeight = (h + 100) + 'px';
            }
            else {
              this.imgHeight = h + 'px';
            }
          }
          //
          this.offsetLeft = elm.offsetLeft;
          this.offsetTop = elm.offsetTop;
        }
        /*
        if (hratio > wratio) {
          const actuallyHeight = wratio * this.imageHeight;
          this.offsetTop += (elm.offsetHeight - actuallyHeight) / 2;
        }
        else {
          const actuallyWidth = hratio * this.imageWidth;
          this.offsetLeft += (elm.offsetWidth - actuallyWidth) / 2;
        }
        */
        //console.log(`offset: left=${this.offsetLeft} top=${this.offsetTop}`);
        this.$emit('imgLoaded', {
          srcw: img.width, srch: img.height
        });
      })
      .catch(err => {
        console.log(`ImageViewer.initImageInfo(${srcUrl}) caught exception:`);
        console.log(err);
      });
    },
    imageLoaded() {
      this.loading = false;
    },
    cancelLoad() {
      this.loading = false;
    },
    loadError() {
      this.loading = false;
      this.error = true;
      this.errMessage = '画像ファイルが読み込めません。';
    },
    dialogClose() {
      this.loading = false;
      this.error = false;
    }
  }
}
</script>
<style lang="scss" scoped>
.image-viewer {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: auto;
}

.grab-bing {
	cursor : -webkit-grab;
	cursor : -moz-grab;
	cursor : -o-grab;
	cursor : grab;
}
    
.grab-bing:active {
	cursor : -webkit-grabbing;
	cursor : -moz-grabbing;
	cursor : -o-grabbing;
	cursor : grabbing;
}

.scroll-hidden {
	overflow: hidden;
}

.v-image {
	transition: 0.1s;
  width: 100%;
  height: 100%;
  // background-position: center center !important;
}
.description {
  position: absolute;
  top: calc(100% - 115px);
  background-color: white;
  font-family: 'MS Gothic';
  font-size: 9pt;
  padding-left: 10mm;
  overflow-x: hidden;
  user-select: none;
}
main > p{ width:800px; }
/*以下はタブレット以下のサイズ用*/
@media screen and (min-width:0px) and (max-width: 1023px){
   main > p{ width:100%; height:600px; }
   main > p img{ height:100%; }
}
</style>